import classnames from "classnames";
import { Row, Col, Button } from "reactstrap";
import { ModalOverlay, ModalBox } from "./ModalStyled";

const RoleConfirmation = (props) => {
  return (
    <ModalOverlay className={classnames({ show: props.show })}>
      <ModalBox className="smBox">
        <h2 className="modal-title">Admin Role Confirmation</h2>
        <p className="sub-title">
          Note: As a admin, user has full authority on all the features
        </p>
        <p className="modal-text">
          Are you sure you want to make{" "}
          <b>
            {props.data && props.data.first_name}{" "}
            {props.data && props.data.last_name}
          </b>{" "}
          an admin?
        </p>
        <Row>
          <Col>
            <Button
              className="btn-gray"
              block
              onClick={() => props.toggle(false, props.data)}
            >
              Cancel
            </Button>
          </Col>
          <Col>
            <Button
              className="btn-blue"
              block
              onClick={() => props.toggle(true, props.data)}
            >
              Yes, Proceed
            </Button>
          </Col>
        </Row>
      </ModalBox>
    </ModalOverlay>
  );
};

export default RoleConfirmation;
